// This file was copied from site scanner. Planning to move it to ui-common.
import React, { FC, useEffect, useMemo } from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import { EvSpinner } from '@evinced-private/ui-common';

import { JiraApi } from 'src/common/services/api/JiraApi';

import { useUniversalLogin } from '../../../../common/hooks/useUniversalLogin';

export const JiraAuthenticationPage: FC = () => {
	const history = useHistory();

	const search = useMemo(() => history?.location?.search, [history]);
	const { isAuthenticated } = useUniversalLogin();

	useEffect(() => {
		if (search) {
			const queryParams = new URLSearchParams(search);
			const code = queryParams.get('code');
			if (code) {
				JiraApi.getAndSaveJiraToken(code);
			}
		}
	}, [search]);

	if (!isAuthenticated()) {
		return <Redirect to="/login" />;
	}

	return <EvSpinner />;
};
